import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/vigor-alimentos-logo-branco.png'
import _imports_1 from '../assets/img/icons/lingua-1.svg'
import _imports_2 from '../assets/img/icons/lingua-2.svg'
import _imports_3 from '../assets/img/icons/search-white.svg'
import _imports_4 from '../assets/img/icons/acessibilidade-icon-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-84d29530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid container-xxl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid d-block mb-auto logo me-3",
  alt: "Logo Vigor",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white me-2" }, "Menu", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "navbar-nav align-items-center ms-auto information" }
const _hoisted_7 = { class: "nav-item d-block d-lg-none mt-3 mt-md-0" }
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = {
  key: 0,
  class: "img-fluid m-auto social-icons",
  alt: "Lingua selecionada Português",
  src: _imports_1
}
const _hoisted_11 = {
  key: 1,
  class: "img-fluid m-auto social-icons",
  alt: "Selected language english",
  src: _imports_2
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid d-block m-auto social-icons",
  alt: "Lingua 1",
  src: _imports_1
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid d-block m-auto social-icons",
  alt: "Lingua 2",
  src: _imports_2
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nav-item dropdown" }
const _hoisted_18 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_19 = { class: "dropdown-menu acessibilidade" }
const _hoisted_20 = { class: "nav-item d-none d-lg-block" }
const _hoisted_21 = { class: "nav-item border-0 d-none d-lg-block" }
const _hoisted_22 = { class: "search-box" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn p-0 d-flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "",
    alt: "Procurar",
    src: _imports_3
  })
], -1))
const _hoisted_25 = { class: "nav-item border-0" }
const _hoisted_26 = {
  href: "https://www.facebook.com/VigorBrasil/",
  target: "_blank"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "nav-item border-0" }
const _hoisted_29 = {
  href: "https://www.instagram.com/vigorbrasil",
  target: "_blank"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "nav-item border-0" }
const _hoisted_32 = {
  href: "https://www.youtube.com/c/vigorbrasil",
  target: "_blank"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "nav-item border-0" }
const _hoisted_35 = {
  href: "https://www.linkedin.com/company/vigor-alimentos/",
  target: "_blank"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "navbar-nav align-items-center ms-auto" }
const _hoisted_38 = { class: "nav-item dropdown" }
const _hoisted_39 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_40 = {
  class: "dropdown-menu",
  id: "institucional"
}
const _hoisted_41 = { class: "nav-item dropdown" }
const _hoisted_42 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_43 = { class: "dropdown-menu" }
const _hoisted_44 = {
  key: 0,
  href: "https://www.danubio.com.br/",
  class: "dropdown-item link",
  target: "_blank"
}
const _hoisted_45 = {
  key: 1,
  href: "https://faixaazul.com.br/",
  class: "dropdown-item link",
  target: "_blank"
}
const _hoisted_46 = { class: "nav-item" }
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = { class: "nav-item" }
const _hoisted_49 = { class: "nav-item" }
const _hoisted_50 = { class: "nav-item border-0 d-block d-lg-none" }
const _hoisted_51 = { class: "search-box" }
const _hoisted_52 = ["placeholder"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn p-0 d-flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "",
    alt: "Procurar",
    src: _imports_3
  })
], -1))
const _hoisted_54 = { class: "nav-item information-2 border-0" }
const _hoisted_55 = {
  href: "https://www.facebook.com/VigorBrasil/",
  target: "_blank"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "nav-item information-2 border-0" }
const _hoisted_58 = {
  href: "https://www.instagram.com/vigorbrasil",
  target: "_blank"
}
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "nav-item information-2 border-0" }
const _hoisted_61 = {
  href: "https://www.youtube.com/c/vigorbrasil",
  target: "_blank"
}
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "nav-item information-2 border-0" }
const _hoisted_64 = {
  href: "https://www.linkedin.com/company/vigor-alimentos/",
  target: "_blank"
}
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "nav-item ms-2 information-2 border-0" }
const _hoisted_67 = { class: "search-box-2" }
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn p-0 d-flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "nav-link",
    alt: "Procurar",
    src: _imports_3
  })
], -1))
const _hoisted_70 = { class: "nav-item dropdown information-2" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle d-flex align-items-center",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "social-icons nav-link",
    alt: "Acessibilidade",
    src: _imports_4
  })
], -1))
const _hoisted_72 = { class: "dropdown-menu dropdown-menu-end acessibilidade" }
const _hoisted_73 = { class: "nav-item dropdown information-2" }
const _hoisted_74 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_75 = {
  key: 0,
  class: "img-fluid m-auto social-icons",
  alt: "Lingua selecionada Português",
  src: _imports_1
}
const _hoisted_76 = {
  key: 1,
  class: "img-fluid m-auto social-icons",
  alt: "Selected language english",
  src: _imports_2
}
const _hoisted_77 = { class: "dropdown-menu dropdown-menu-end dropdown-menu-xxl-start" }
const _hoisted_78 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_79 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_80 = { class: "d-flex align-items-center justify-content-center d-block d-lg-none mt-3" }
const _hoisted_81 = ["src"]
const _hoisted_82 = ["src"]
const _hoisted_83 = ["src"]
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  class: "navbar-toggler mt-3",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg fixed-top", { scrolled: _ctx.scrolled, menuMobile: _ctx.menuMobile }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarNav",
        "aria-controls": "navbarNav",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onScrolled()))
      }, _hoisted_5),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse flex-column text-center", !_ctx.visible ? 'collapse' : '']),
        id: "navbarNav"
      }, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/fale-conosco",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {
								_ctx.visible = !_ctx.visible;
								_ctx.onScrolled();
							})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('header.fale-conosco')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              (_ctx.locale == 'pt')
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.locale == 'en')
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.locale = 'pt'))
                }, _hoisted_14)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.locale = 'en'))
                }, _hoisted_16)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t('header.acessibilidade')), 1),
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "1",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.contrastToggle && _ctx.contrastToggle(...args)))
                }, _toDisplayString(_ctx.$t('header.alto-contraste')) + " [1]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.increaseFont && _ctx.increaseFont(...args)))
                }, _toDisplayString(_ctx.$t('header.aumentar-fonte')) + " [2]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "3",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.normalFont && _ctx.normalFont(...args)))
                }, _toDisplayString(_ctx.$t('header.tamanho-normal')) + " [3]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "4",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.decreaseFont && _ctx.decreaseFont(...args)))
                }, _toDisplayString(_ctx.$t('header.diminuir-fonte')) + " [4]", 1)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/fale-conosco"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('header.fale-conosco')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
              autocomplete: "off"
            }, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "search-input",
                  placeholder: _ctx.$t('header.procurar'),
                  "aria-label": "Procurar...",
                  name: "search-term",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.search) = $event))
                }, null, 8, _hoisted_23), [
                  [_vModelText, _ctx.search]
                ]),
                _hoisted_24
              ])
            ], 32)
          ]),
          _createElementVNode("li", _hoisted_25, [
            _createElementVNode("a", _hoisted_26, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link d-none d-lg-block",
                alt: "Facebook",
                src: require('@/assets/img/Facebook.svg')
              }, null, 8, _hoisted_27)
            ])
          ]),
          _createElementVNode("li", _hoisted_28, [
            _createElementVNode("a", _hoisted_29, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link d-none d-lg-block",
                alt: "Instagram",
                src: require('@/assets/img/Instagram.svg')
              }, null, 8, _hoisted_30)
            ])
          ]),
          _createElementVNode("li", _hoisted_31, [
            _createElementVNode("a", _hoisted_32, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link d-none d-lg-block",
                alt: "You Tube",
                src: require('@/assets/img/Youtube.svg')
              }, null, 8, _hoisted_33)
            ])
          ]),
          _createElementVNode("li", _hoisted_34, [
            _createElementVNode("a", _hoisted_35, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link d-none d-lg-block",
                alt: "Linkedin",
                src: require('@/assets/img/Linkedin.svg')
              }, null, 8, _hoisted_36)
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_37, [
          _createElementVNode("li", _hoisted_38, [
            _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.$t('header.institucional')), 1),
            _createElementVNode("ul", _hoisted_40, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/nossa-historia",
                  class: "dropdown-item",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.nossa-historia')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/nossas-lojas",
                  class: "dropdown-item",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.nossas-lojas')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/nossa-cultura",
                  class: "dropdown-item",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nossa-cultura.nossa-cultura')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/exportacao",
                  class: "dropdown-item",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.exportacao')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/imprensa",
                  class: "dropdown-item",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('header.imprensa')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_41, [
            _createElementVNode("a", _hoisted_42, _toDisplayString(_ctx.$t('header.nossas-marcas')), 1),
            _createElementVNode("ul", _hoisted_43, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcas, (marca, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  (marca.name == 'Danubio')
                    ? (_openBlock(), _createElementBlock("a", _hoisted_44, _toDisplayString(marca.name), 1))
                    : (marca.name == 'Faixa Azul')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_45, _toDisplayString(marca.name), 1))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: { name: 'Brands Amigavel', params: { name_brand: marca.slug }},
                          class: "dropdown-item link",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => {
										_ctx.visible = !_ctx.visible;
										_ctx.onScrolled();
									})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(marca.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("li", _hoisted_46, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/receitas",
              onClick: _cache[16] || (_cache[16] = ($event: any) => {
								_ctx.visible = !_ctx.visible;
								_ctx.onScrolled();
							})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('header.receitas')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_47, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/academia-do-queijo",
              onClick: _cache[17] || (_cache[17] = ($event: any) => {
								_ctx.visible = !_ctx.visible;
								_ctx.onScrolled();
							})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('header.academia-do-queijo')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_48, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "/brincando-com-vigor",
              onClick: _cache[18] || (_cache[18] = ($event: any) => {
								_ctx.visible = !_ctx.visible;
								_ctx.onScrolled();
							})
            }, _toDisplayString(_ctx.$t('header.area-kids')), 1)
          ]),
          _createElementVNode("li", _hoisted_49, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/trabalhe-conosco",
              onClick: _cache[19] || (_cache[19] = ($event: any) => {
								_ctx.visible = !_ctx.visible;
								_ctx.onScrolled();
							})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('header.trabalhe-conosco')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_50, [
            _createElementVNode("form", {
              onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
              autocomplete: "off"
            }, [
              _createElementVNode("div", _hoisted_51, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "search-input",
                  placeholder: _ctx.$t('header.procurar'),
                  "aria-label": "Procurar...",
                  name: "search-term",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.search) = $event))
                }, null, 8, _hoisted_52), [
                  [_vModelText, _ctx.search]
                ]),
                _hoisted_53
              ])
            ], 32)
          ]),
          _createElementVNode("li", _hoisted_54, [
            _createElementVNode("a", _hoisted_55, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link",
                alt: "Facebook",
                src: require('@/assets/img/Facebook.svg')
              }, null, 8, _hoisted_56)
            ])
          ]),
          _createElementVNode("li", _hoisted_57, [
            _createElementVNode("a", _hoisted_58, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link",
                alt: "Instagram",
                src: require('@/assets/img/Instagram.svg')
              }, null, 8, _hoisted_59)
            ])
          ]),
          _createElementVNode("li", _hoisted_60, [
            _createElementVNode("a", _hoisted_61, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link",
                alt: "You Tube",
                src: require('@/assets/img/Youtube.svg')
              }, null, 8, _hoisted_62)
            ])
          ]),
          _createElementVNode("li", _hoisted_63, [
            _createElementVNode("a", _hoisted_64, [
              _createElementVNode("img", {
                class: "social-icons social-network-icon nav-link",
                alt: "Linkedin",
                src: require('@/assets/img/Linkedin.svg')
              }, null, 8, _hoisted_65)
            ])
          ]),
          _createElementVNode("li", _hoisted_66, [
            _createElementVNode("form", {
              onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
              autocomplete: "off"
            }, [
              _createElementVNode("div", _hoisted_67, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "search-input-2",
                  placeholder: _ctx.$t('header.procurar'),
                  "aria-label": "Procurar...",
                  name: "search-term",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.search) = $event))
                }, null, 8, _hoisted_68), [
                  [_vModelText, _ctx.search]
                ]),
                _hoisted_69
              ])
            ], 32)
          ]),
          _createElementVNode("li", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("ul", _hoisted_72, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "1",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.contrastToggle && _ctx.contrastToggle(...args)))
                }, _toDisplayString(_ctx.$t('header.alto-contraste')) + " [1]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "2",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.increaseFont && _ctx.increaseFont(...args)))
                }, _toDisplayString(_ctx.$t('header.aumentar-fonte')) + " [2]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "3",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.normalFont && _ctx.normalFont(...args)))
                }, _toDisplayString(_ctx.$t('header.tamanho-normal')) + " [3]", 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  role: "button",
                  class: "dropdown-item",
                  accesskey: "4",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.decreaseFont && _ctx.decreaseFont(...args)))
                }, _toDisplayString(_ctx.$t('header.diminuir-fonte')) + " [4]", 1)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_73, [
            _createElementVNode("a", _hoisted_74, [
              (_ctx.locale == 'pt')
                ? (_openBlock(), _createElementBlock("img", _hoisted_75))
                : _createCommentVNode("", true),
              (_ctx.locale == 'en')
                ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("ul", _hoisted_77, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_78, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block m-auto social-icons",
                    alt: "Lingua 1",
                    src: _imports_1,
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.locale = 'pt'))
                  })
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_79, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block m-auto social-icons",
                    alt: "Lingua 2",
                    src: _imports_2,
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.locale = 'en'))
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("a", {
            class: "me-4",
            href: "https://www.facebook.com/VigorBrasil/",
            target: "_blank",
            onClick: _cache[30] || (_cache[30] = ($event: any) => {
							_ctx.visible = !_ctx.visible;
							_ctx.onScrolled();
						})
          }, [
            _createElementVNode("img", {
              class: "social-icons social-network-icon",
              src: require('@/assets/img/Facebook.svg'),
              alt: "Facebook Vigor"
            }, null, 8, _hoisted_81)
          ]),
          _createElementVNode("a", {
            class: "me-4",
            href: "https://www.instagram.com/vigorbrasil",
            target: "_blank",
            onClick: _cache[31] || (_cache[31] = ($event: any) => {
							_ctx.visible = !_ctx.visible;
							_ctx.onScrolled();
						})
          }, [
            _createElementVNode("img", {
              class: "social-icons social-network-icon",
              src: require('@/assets/img/Instagram.svg'),
              alt: "Instagram Vigor"
            }, null, 8, _hoisted_82)
          ]),
          _createElementVNode("a", {
            class: "me-4",
            href: "https://www.youtube.com/c/vigorbrasil",
            target: "_blank",
            onClick: _cache[32] || (_cache[32] = ($event: any) => {
							_ctx.visible = !_ctx.visible;
							_ctx.onScrolled();
						})
          }, [
            _createElementVNode("img", {
              class: "social-icons social-network-icon",
              src: require('@/assets/img/Youtube.svg'),
              alt: "YouTube Vigor"
            }, null, 8, _hoisted_83)
          ]),
          _createElementVNode("a", {
            class: "me-4",
            href: "https://www.linkedin.com/company/vigor-alimentos/",
            target: "_blank",
            onClick: _cache[33] || (_cache[33] = ($event: any) => {
							_ctx.visible = !_ctx.visible;
							_ctx.onScrolled();
						})
          }, [
            _createElementVNode("img", {
              class: "social-icons social-network-icon",
              src: require('@/assets/img/Linkedin.svg'),
              alt: "Linkedln Vigor"
            }, null, 8, _hoisted_84)
          ])
        ]),
        _createElementVNode("button", _hoisted_85, [
          _createElementVNode("span", {
            class: "text-white",
            onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.onScrolled && _ctx.onScrolled(...args)))
          }, _toDisplayString(_ctx.$t('header.voltar')), 1)
        ])
      ], 2)
    ])
  ], 2))
}